import { FighterTile } from './FighterTile';
import type { CharacterRow } from '../lib/types';

interface PaletteGridProps {
  variants: CharacterRow[];
  selectedId: number | null;
  disabled?: boolean;
  onSelectPalette: (id: number) => void;
}

export function PaletteGrid({
  variants,
  selectedId,
  disabled = false,
  onSelectPalette,
}: PaletteGridProps) {
  return (
    <div className="smash-fighter-grid">
      {variants.map((v, index) => {
        const isTaken = v.taken === 1 && v.id !== selectedId;
        const isSelected = v.id === selectedId;

        return (
          <FighterTile
            key={v.id}
            imageUrl={v.image_url}
            selected={isSelected}
            disabled={isTaken || disabled}
            onClick={() => onSelectPalette(v.id)}
            index={index}
            total={variants.length}
          />
        );
      })}
    </div>
  );
}
